import Vue from 'vue';
const Bus = new Vue();

const install = function() {
    Vue.prototype.$bus = Bus;
};
export default install;
